/* ll-home-card.js · the shared Llama Land product card (snippets/ll-card.liquid), owner: homepage builder.
   Loaded deferred by any section that renders ll-card (homepage shop, collection grids). One delegated click handler on
   document, so it survives AJAX filter re-renders and theme-editor reloads. A flavour chip swaps the card's variant,
   selling plan, prices, links, jar image, tile colour, rating and labels in place; the native form then adds exactly
   what the card shows (UpCart intercepts the submit). Motion (GSAP present + html.motion): the tile crossfades and the
   new jar settles in over the old one; otherwise the swap is instant. */
(function () {
  'use strict';
  if (window.__llCard) return; window.__llCard = true;
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var cache = {};
  function preload(src) {
    if (!src) return Promise.resolve();
    if (cache[src]) return cache[src];
    var im = new Image(); im.decoding = 'async'; im.src = src;
    cache[src] = (im.decode ? im.decode() : new Promise(function (r) { im.onload = r; im.onerror = r; })).catch(function () {});
    return cache[src];
  }
  function moving() { return !!(W.gsap && D.documentElement.classList.contains('motion') && W.LNMotion && W.LNMotion.motion); }
  function setTrack(el, attr, handle) { if (!el) return; var v = el.getAttribute(attr); if (v) el.setAttribute(attr, v.replace(/--[^-][\s\S]*$/, '--' + handle)); }

  D.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-ll-flavor]');
    if (!chip) return;
    var card = chip.closest('[data-ll-card]'); if (!card) return;
    if (chip.getAttribute('aria-pressed') === 'true') return;
    $$('[data-ll-flavor]', card).forEach(function (x) { var on = x === chip; x.classList.toggle('ll-c-is-on', on); x.setAttribute('aria-pressed', String(on)); });
    var g = function (a) { return chip.getAttribute('data-' + a) || ''; };
    var name = g('flavor'), tile = g('tile'), handle = g('handle'), url = g('url');
    var nm = $('[data-ll-flavor-name]', card); if (nm) nm.textContent = name;
    var st = $('[data-ll-flavor-status]', card); if (st) st.textContent = name;
    /* commerce: what the form adds = what the card shows */
    var v = $('[data-ll-variant]', card); if (v) v.value = g('variant');
    var pl = $('[data-ll-plan]', card); if (pl) { pl.value = g('plan'); pl.disabled = !g('plan'); }
    var note = $('[data-ll-plan-note]', card); if (note) note.hidden = !g('plan');
    var add = $('[data-ll-add]', card), form = $('[data-ll-form]', card), shop = $('[data-ll-shop]', card);
    var promo = g('promo') === 'true', avail = g('available') === 'true';
    if (form) form.hidden = promo; if (shop) { shop.hidden = !promo; shop.setAttribute('href', url); }
    if (add) {
      add.disabled = !avail;
      add.setAttribute('aria-label', g('label'));
      setTrack(add, 'data-heatmap-atc', handle);
    }
    setTrack(shop, 'data-heatmap-cta', handle);
    $$('[data-ll-price]', card).forEach(function (p) { p.textContent = g('price'); });
    $$('[data-ll-compare]', card).forEach(function (s) { s.textContent = g('compare'); s.hidden = !g('compare'); });
    $$('[data-ll-link]', card).forEach(function (a) { var h = a.getAttribute('href') || ''; a.setAttribute('href', url + (h.indexOf('#') > -1 ? h.slice(h.indexOf('#')) : '')); });
    var rt = $('[data-ll-rating]', card);
    if (rt && g('rating')) { var tx = $('[data-ll-rating-text]', rt); if (tx) tx.textContent = g('rating') + ' (' + g('count') + ')'; }
    /* look: tile + jar */
    card.style.setProperty('--tile', tile);
    var tintA = $('.ll-c-p-tint', card), tintB = $('.ll-c-p-tint-b', card), jar = $('.ll-c-p-jar', card);
    var src = g('image'), srcset = g('srcset'), alt = g('alt');
    function swapNow() { if (tintA) tintA.style.background = tile; if (jar && src) { jar.setAttribute('src', src); if (srcset) jar.setAttribute('srcset', srcset); jar.alt = alt; } }
    if (!moving() || !jar || !src) { swapNow(); return; }
    var gsap = W.gsap;
    if (tintB) { tintB.style.background = tile; gsap.fromTo(tintB, { opacity: 0 }, { opacity: 1, duration: .26, ease: 'power1.out', onComplete: function () { if (tintA) tintA.style.background = tile; gsap.set(tintB, { opacity: 0 }); } }); }
    var tok = card.__llTok = (card.__llTok || 0) + 1;
    preload(src).then(function () {
      if (tok !== card.__llTok) return;
      if (card.__llIn) { gsap.killTweensOf(card.__llIn); card.__llIn.remove(); }
      var nj = D.createElement('img'); nj.className = 'll-c-p-jar ll-c-p-jar-in'; nj.src = src; nj.alt = ''; nj.width = jar.width || 600; nj.height = jar.height || 600;
      nj.setAttribute('aria-hidden', 'true'); jar.parentNode.appendChild(nj); card.__llIn = nj;
      gsap.to(jar, { yPercent: -6, duration: .24, ease: 'power1.in', overwrite: true });
      gsap.to(jar, { opacity: 0, duration: .16, delay: .1, ease: 'power1.in' });
      gsap.fromTo(nj, { opacity: 0 }, { opacity: 1, duration: .12, delay: .03, ease: 'power1.out' });
      gsap.fromTo(nj, { yPercent: 8, scaleY: .96 }, { yPercent: 0, scaleY: 1, duration: .42, ease: 'settle', delay: .03, onComplete: function () {
        jar.setAttribute('src', src); if (srcset) jar.setAttribute('srcset', srcset); jar.alt = alt;
        var done = function () { if (tok !== card.__llTok) return; gsap.set(jar, { clearProps: 'opacity,transform' }); nj.remove(); if (card.__llIn === nj) card.__llIn = null; };
        if (jar.decode) jar.decode().then(done, done); else done();
      } });
    });
  });
  /* ---------- offer cards (snippets/ll-card.liquid o_show; offer-tag spec 2026-10-23) ----------
     State A: Add = one /cart/add.js line on the card's plan, then the first-order code through cart/update.js keeping the
     cart's other codes (assets/ll-bundle-aligned.js pattern), then /cart.js: the line must equal the card's price per
     unit (1 cent tolerance), else the shopper is told before checkout. The add is never undone. Without JS the form
     opens the bundle page instead. State B: the card's SHOP link. PREVIEW ONLY: ?offer_card=a|b picks the state on
     cards that carry both (kept for the browser session); remove with the theme setting once Brad picks. */
  function offerMode() {
    var m = '';
    try { m = (new URL(W.location.href).searchParams.get('offer_card') || '').toLowerCase(); } catch (_) {}
    try { if (m === 'a' || m === 'b') W.sessionStorage.setItem('ll_offer_card', m); else m = W.sessionStorage.getItem('ll_offer_card') || ''; } catch (_) {}
    return m === 'a' || m === 'b' ? m : '';
  }
  var oMode = offerMode();
  function applyOfferMode(root) {
    if (!oMode) return;
    $$('[data-ll-card-offer]', root).forEach(function (card) {
      var modes = (card.getAttribute('data-ll-card-offer') || '').split(' ');
      if (modes.indexOf(oMode) < 0) return;
      var form = $('[data-ll-card-offer-form]', card), shop = $('[data-ll-shop]', card);
      if (form) form.hidden = oMode !== 'a';
      if (shop) shop.hidden = oMode !== 'b';
    });
  }
  if (oMode) {
    applyOfferMode(D);
    if ('MutationObserver' in W) new MutationObserver(function () { applyOfferMode(D); }).observe(D.documentElement, { childList: true, subtree: true });
  }
  function jpost(url, body) {
    return W.fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok) throw new Error(b.description || b.message || 'Could not add to cart. Please try again.'); return b; }); });
  }
  function readCart() { return W.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error('cart read ' + r.status); return r.json(); }); }
  D.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-ll-card-offer-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-ll-add]', form), err = $('[data-ll-card-offer-err]', form);
    if (!btn || btn.disabled) return;
    var vid = Number(($('[data-ll-variant]', form) || {}).value), plan = Number(($('[data-ll-plan]', form) || {}).value);
    var code = form.getAttribute('data-code') || '', expected = Number(form.getAttribute('data-expected'));
    var same = function (c) { return String(c).toUpperCase() === code.toUpperCase(); };
    if (!vid || !plan || !code || !(expected > 0)) { W.location.href = form.getAttribute('action'); return; }
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
    jpost('/cart/add.js', { items: [{ id: vid, quantity: 1, selling_plan: plan }] })
      .then(function (body) {
        var added = (body.items || []).find(function (i) { return Number(i.variant_id || i.id) === vid; });
        var sp = added && added.selling_plan_allocation && added.selling_plan_allocation.selling_plan;
        if (!added || !sp || Number(sp.id) !== plan) throw new Error('Please review your cart to confirm the selected purchase option before checking out.');
        return readCart();
      })
      .then(function (cart) {
        if ((cart.discount_codes || []).some(function (d) { return same(d.code) && d.applicable; })) return cart;
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        if (!codes.some(same)) codes.push(code);
        return jpost('/cart/update.js', { discount: codes.join(',') }).then(readCart);
      })
      .then(function (cart) {
        var line = (cart.items || []).find(function (i) {
          var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
          return Number(i.variant_id) === vid && sp && Number(sp.id) === plan;
        });
        var unit = line ? Math.round(line.final_line_price / line.quantity) : -1;
        if (typeof W.upcartRefreshCart === 'function') W.upcartRefreshCart();
        if (Math.abs(unit - expected) > 1) throw new Error('Please review your cart to confirm the selected purchase option before checking out.');
        if (typeof W.upcartOpenCart === 'function') W.upcartOpenCart();
        D.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (x) { if (err) { err.textContent = (x && x.message) || 'Could not add to cart. Please try again.'; err.hidden = false; } })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }, true);
  /* warm the other flavour's jar on idle so a swap never waits */
  var warm = function () { $$('[data-ll-flavor][data-image]').forEach(function (b) { preload(b.getAttribute('data-image')); }); };
  if ('requestIdleCallback' in W) W.requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1500);
})();
